






























































































import { Component, Vue } from "vue-property-decorator";
import { delNullProperty } from "@/utils/index";
import axios from "axios";
import { Loading } from "element-ui";
import vantSelect from './vant-select.vue'
import CommonData from "@/utils/commonData";

@Component({
  name: "AppLicationForm",
  components: { vantSelect }
})
export default class extends Vue {
  private schoolShow = false;  //就读学校
  private attendSchoolShow = false;  //性别
  private genderDisable = true;  //性别禁用
  private gradeShow = false;  //当前年级
  
  private school = {};
  private isDisable = false;
  private gender = "";
  private options = [
    { text: '男',label: '男'},
    { text: '女',label: '女'},
  ];
  private gradeList = CommonData.gradeListOfB
  private grade = "";
  private specialized = "";
  private eduTemandOptions = [ '留学', '高考', '考研', '保研', '考博', '无升学需求' ];
  private schoolList = [];
  private page = 1;
  private name = null;
  private schoolId = ""; //学校id
  private attendSchool = null;
  private customerName = "";
  private phone = "";
  private weChat = "";
  private email = "";
  private remark = "";
  private directorUserId = "";
  private from: "market" | "customer" = "market";
  private errorInfos = {
    // 存放对应输入框的报错信息，在提交的时候统一验证
    name: "",
    phone: "",
    weChat: "",
    attendSchool: "",
    grade: "",
    email: "",
    gender: "",
    remark: ""
  };
  private axios = null;
  private resultSuccess = false; // 提交成功
  private resultError = false

  created() {
    const query = this.$route.query;
    this.directorUserId = query.userId as string;
    this.from = query.from as "market" | "customer";
    this.createAxios();
    this.getSchoolList();
  }

  mounted() {
    this.setDocumentFontSize();
    window.addEventListener("resize", this.setDocumentFontSize);
  }
  createAxios() {
    const origin = location.hostname; //当前访问域名
    let requestBase = "";
    if (process.env.NODE_ENV === "development") {
      requestBase = process.env.VUE_APP_BASE_CRM_API_PROXY;
    } else {
      if (origin.indexOf("-testserver") > -1) {
        requestBase = process.env.VUE_APP_DEV_API;
      } else {
        requestBase = process.env.VUE_APP_MASTER_API;
      }
    }
    const config = {
      baseURL: requestBase,
      timeout: 30 * 1000, // Timeout
    };

    this.axios = axios.create(config);
  }

  destroyed() {
    document.documentElement.style.fontSize = "16px";
  }

  submitForm() {
    let isComplete = true;
    /* 清空报错信息 */
    for (const key in this.errorInfos) {
      this.errorInfos[key] = "";
    }
    /* 非空验证 */
    if (this.checkNull(this.customerName)) {
      this.errorInfos.name = "请填写客户名称";
      isComplete = false;
    }
    if (this.checkNull(this.phone)) {
      this.errorInfos.phone = "请填写电话";
      isComplete = false;
    }
    if (this.checkNull(this.weChat)) {
      this.errorInfos.weChat = "请填写微信";
      isComplete = false;
    }
    if (this.checkNull(this.email)) {
      this.errorInfos.email = "请填写邮箱";
      isComplete = false;
    }
 
    if (this.checkNull(this.gender)) {
      this.errorInfos.gender = "请选择性别";
      isComplete = false;
    }
    if (this.checkNull(this.attendSchool)) {
      this.errorInfos.attendSchool = "请选择学校";
      isComplete = false;
    }
    if (this.checkNull(this.grade)) {
      this.errorInfos.grade = "请选择年级";
      isComplete = false;
    }
    if (this.checkNull(this.remark)) {
      this.errorInfos.remark = "请填写项目名称";
      isComplete = false;
    }


    if (isComplete) {
      this.setCustomerBusinessByQrcode();
    }
  }

  checkNull(value: string | number): boolean {
    return ["", null, undefined, NaN].includes(value);
  }
  listenSchool(data) {
    if(data != false){
      this.schoolId = data.id
      this.attendSchool = data.text
    }
    
    this.schoolShow = false
  }
  handleSchool(data) {
    this.schoolList = data
  }
  // 性别
  listenAttend(data) {
    if(data != false){
      this.gender = data.text
    }
    this.attendSchoolShow = false
    // this.genderDisable = false
  }
  // 年级
  listenGrade(data) {
    if(data != false){
      this.grade = data
    }
    this.gradeShow = false
  }
  showPopup () {
    this.schoolShow = true
    // this.getSchoolList();
  }
  attendShowPopup () { //性别
    this.attendSchoolShow = true
  }
  gradeShowPopup () { //年级
    this.gradeShow = true
  }
  //B端客户学校列表
  async getSchoolList() {
    const loading = this.$loading({
      lock: true,
      text: "Loading",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    this.axios
      .post(
        "/tools/getSchoolList",
        delNullProperty({
          name: this.name,
          page: this.page,
        })
      )
      .then(({ data }) => {
        // 判断错误状态
        this.schoolList = [...this.schoolList, ...data.data.schoolList]
        this.schoolList = this.schoolList.map(item => ({ id: item.id, text: item.name }))
        loading.close();
      })
      .catch((err) => {
        loading.close();
      });
  }

  // 提交客户
  async setCustomerBusinessByQrcode() {
    if(this.isDisable == true){
      return
    }
    const loading = this.$loading({
      lock: true,
      text: "Loading",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });

    this.axios
      .post(
        "/customer/setCustomerBusinessByQrcode",
        delNullProperty({
          name: this.customerName,
          phone: this.phone,
          directorUserId: this.directorUserId,
          weChat: this.weChat,
          email: this.email,
          gender: this.gender,
          attendSchool: this.attendSchool,
          schoolId: this.schoolId,
          grade: this.grade,
          specialized: this.specialized,
          remark: this.remark,
        })
      )
      .then(({ data }) => {
        if (data.error.returnCode === 0) {
          this.resultSuccess = true;
        }
        this.isDisable = true
        loading.close();
      })
      .catch((res) => {
        loading.close();
        this.resultError = true
      });
  }

  closePage() {
    window.open("about:blank", "_self").close();
  }

  // 设置跟元素字体大小
  private setDocumentFontSize() {
    document.documentElement.style.fontSize =
      document.documentElement.getBoundingClientRect().width / 7.5 + "px";
  }
}
